var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4534 19.3064L20.3668 14.4331C19.6601 12.7798 18.3601 12.7131 17.4868 14.2864L16.2268 16.5598C15.5868 17.7131 14.3934 17.8131 13.5668 16.7798L13.4201 16.5931C12.5601 15.5131 11.3468 15.6464 10.7268 16.8798L9.58011 19.1798C8.77345 20.7798 9.94011 22.6664 11.7268 22.6664H20.2334C21.9668 22.6664 23.1334 20.8998 22.4534 19.3064Z",
    stroke: "#5D5F61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6465 13.333C13.7511 13.333 14.6465 12.4376 14.6465 11.333C14.6465 10.2284 13.7511 9.33301 12.6465 9.33301C11.5419 9.33301 10.6465 10.2284 10.6465 11.333C10.6465 12.4376 11.5419 13.333 12.6465 13.333Z",
    stroke: "#5D5F61",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#EAEAEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholderIcon);
export default __webpack_public_path__ + "static/media/image-placeholder-icon.f3d12fc84342605c5f4aeafe20f29fd0.svg";
export { ForwardRef as ReactComponent };